import { Box, Container, Link, Typography, styled } from '@mui/material';

const FooterWrapper = styled(Container)(
  ({ theme }) => `
        margin-top: ${theme.spacing(4)};
`
);

function Footer() {
  return (
    <FooterWrapper className="footer-wrapper">
      <Box pb={4} display={{ xs: 'block', md: 'flex' }} alignItems="center" textAlign={{ xs: 'center', md: 'center' }} justifyContent="center">
        <Typography variant="subtitle1" color="#ffffff">
          &copy; 2024 - RotoGPT, LLC. All rights reserved.
        </Typography>
      </Box>
    </FooterWrapper>
  );
}

export default Footer;
